__turbopack_context__.v({
  "header": "Header-module__arFiJq__header",
  "headerContainer": "Header-module__arFiJq__headerContainer",
  "isActive": "Header-module__arFiJq__isActive",
  "layoutFix": "Header-module__arFiJq__layoutFix",
  "light": "Header-module__arFiJq__light",
});
